import { getMandatoryBIFields } from '@wix/business-manager-api';
import webBiLogger from '@wix/web-bi-logger';
import React, { useMemo } from 'react';
import { BiLoggerContext } from '../contexts';
export const BiLoggerProvider = _ref => {
  let {
    children,
    metaSiteId
  } = _ref;
  const biLogger = useMemo(() => {
    let mandatoryBIFields = {};
    try {
      mandatoryBIFields = getMandatoryBIFields();
    } catch {}
    return webBiLogger.factory().updateDefaults({
      ...mandatoryBIFields,
      msid: metaSiteId
    }).logger();
  }, [metaSiteId]);
  const value = useMemo(() => ({
    biLogger
  }), [biLogger]);
  return /*#__PURE__*/React.createElement(BiLoggerContext.Provider, {
    value: value
  }, children);
};
//# sourceMappingURL=BiLoggerProvider.js.map